import Request from './base/Request';
import * as base64 from 'base-64';

class CellAuthRequest extends Request {
    constructor(APIURL, body) {
        super(APIURL);

        if(!['s','c'].includes(body.devide.toLowerCase()))
            throw Error('잘못된 구분입니다');

        this.options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body)
        };

        this.request = this.request.bind(this);
    }
}

export default CellAuthRequest;
